import IconText from 'components/IconText';
import { cn, cnm } from 'utils/classNames';
import { asArray, is } from 'utils/helpers';
import { ensureTrailingPunctuation } from 'utils/string';

interface Props {
	className?: string;
	errorMessage: string | string[] | undefined;
	errorMessageId: string;
	helpText: string | undefined;
	helpTextId: string;
	invalid: boolean | undefined;
}

/** Help text and error messages. */
export default function InputInfo({
	className,
	errorMessage,
	errorMessageId,
	helpText,
	helpTextId,
	invalid = false,
}: Props) {
	const errors = asArray(errorMessage).filter(
		(error) => error && error !== ' ',
	);
	const showErrors = invalid && is.arrayWithLength(errors);
	// If there are multiple errors, ensure they end with punctuation to make
	// screen readers pause between them.
	const errorMessages =
		errors.length > 1
			? errors.map((message) => ensureTrailingPunctuation(message))
			: errors;

	// Always render containers even if empty - it's required for ARIA.
	return (
		<div className={cnm((showErrors || helpText) && 'mt-1', className)}>
			<p className="text-sm text-subtle" id={helpTextId}>
				{helpText}
			</p>
			<div
				className={cn('space-y-0.5 text-error', helpText && 'mt-1')}
				id={errorMessageId}
			>
				{showErrors &&
					errorMessages.map((message) => (
						<IconText
							key={message}
							as="p"
							icon="circle-error"
							size="sm"
							text={message}
						/>
					))}
			</div>
		</div>
	);
}
InputInfo.displayName = 'FormUI_InputInfo';
